import React, {useEffect, useState} from "react";
import {Button, DialogActions, DialogContent} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import Call from "../../hocs/call";
import CustomJsonForms from "../custom-json-forms";
import FullscreenDialog from "../fullscreen-dialog";
import {
  createPackage,
  getPackage,
  getPackageSchema,
  hidePackage,
  updatePackage
} from "../../state/package-manager/packageManagerActions";
import {packageManagerSelector} from "../../state/package-manager/packageManagerSelectors";

const PackageSettings = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const {
    isPackageSettingsModalVisible,
    nodeId,
    packageSchema,
    packageUiSchema,
    packageId,
    package: pkg
  } = useSelector(packageManagerSelector);

  const [data, setData] = useState(null);
  const [errors, setErrors] = useState(null);
  const [showValidation, setShowValidation] = useState(false);

  const fetchPackageSchema = nodeId => {
    dispatch(getPackageSchema(nodeId));
  };

  const fetchPackage = ({nodeId, packageId}) => {
    dispatch(getPackage(nodeId, packageId));
  };

  const onPackageSettingsHide = () => {
    dispatch(hidePackage());
  };

  const onPackageSettingsSubmit = () => {
    if ((errors || []).length > 0) {
      setShowValidation(true);
    } else {
      setShowValidation(false);
      if (packageId) {
        dispatch(updatePackage(nodeId, packageId, data));
      } else {
        dispatch(createPackage(nodeId, data));
      }
    }
  };

  useEffect(() => {
    setData(pkg);
    setErrors(null);
    setShowValidation(false);

    return () => {
      setData(null);
      setErrors(null);
      setShowValidation(false);
    };
  }, [pkg]);

  if (!nodeId || !isPackageSettingsModalVisible) {
    return null;
  }

  return (
    <FullscreenDialog
      open={isPackageSettingsModalVisible}
      title={
        packageId
          ? t("modules.packageManager.packageSettings.editPackage.label")
          : t("modules.packageManager.packageSettings.createPackage.label")
      }
      onClose={onPackageSettingsHide}
      onSubmit={onPackageSettingsSubmit}
    >
      <DialogContent>
        <Call cb={fetchPackageSchema} cbParam={nodeId} disabled={Boolean(packageSchema && packageUiSchema)}>
          {packageSchema && packageUiSchema && (
            <Call cb={fetchPackage} cbParam={{nodeId: nodeId, packageId: packageId}} disabled={!packageId}>
              <CustomJsonForms
                schema={packageSchema}
                uischema={packageUiSchema}
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                showValidation={showValidation}
                i18nPrefix={"modules.packageManager.packageSettings"}
              />
            </Call>
          )}
        </Call>
      </DialogContent>
      <DialogActions>
        <Button className="resource-settings__actions__cancel-btn" onClick={onPackageSettingsHide}>
          {t("commons.confirm.cancel")}
        </Button>
        <Button className="resource-settings__actions__submit-btn" onClick={onPackageSettingsSubmit} disabled={!data}>
          {t("commons.confirm.submit")}
        </Button>
      </DialogActions>
    </FullscreenDialog>
  );
};

export default PackageSettings;
